import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Payment  {
    _originalTypeClassName = "zERP.BO.Payment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Payment.translate = translateService;
}
this.Lines = [];
this.FileUploads = [];
this.Id = null;
this.DatePayed = null;
this.IsIncome = false;
this.Reason = null;
this.Submitted = false;
this.MappedWithAccounting = false;
this.IsCanceled = false;
this.ProtocolNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DatePayed:any;
IsIncome:any;
Reason:any;
Submitted:any;
MappedWithAccounting:any;
IsCanceled:any;
ProtocolNumber:any;
PaymentOrder:any;
IncomeReceipt:any;
Lines:any;
Entity:any;
TransactionEntity:any;
Cancellation:any;
FileUploads:any;
CreatedBy:any;
static setPaymentOrder = ($this, value) => {
var oldValue = $this.PaymentOrder;
$this.PaymentOrder = value;
if (value != null) {
if (oldValue != null && oldValue.Payment != null) { oldValue.Payment = null; }
if ($this.PaymentOrder.Payment !== $this) {
Domain.PaymentOrder.setPayment(value, $this);
}
}
}
static setIncomeReceipt = ($this, value) => {
var oldValue = $this.IncomeReceipt;
$this.IncomeReceipt = value;
if (value != null) {
if (oldValue != null && oldValue.Payment != null) { oldValue.Payment = null; }
if ($this.IncomeReceipt.Payment !== $this) {
Domain.IncomeReceipt.setPayment(value, $this);
}
}
}
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.Payment.removeLines($this, $this.Lines[0]);
                }

                Domain.Payment.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Payment.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
if (item.PaymentOrderPayment != $this) {
Domain.PaymentLine.setPaymentOrderPayment(item, $this);
}
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Payment.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
item.PaymentOrderPayment = null;
}
static clearLines = ($this) => { $this.Lines = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setCancellation = ($this, value) => {
var oldValue = $this.Cancellation;
$this.Cancellation = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.Payment.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.Payment.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Payment.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Payment.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}

static AutoFillPaymentAmount($this: any, line: any,totalAmount: any): any{let alreadyPaidAmount = $this?.Lines?.linq?.where((l) => l != line)?.toArray()?.linq?.sum((l) => l?.PaymentAmount);
let remainingAmount = Joove.Common.safeNumber(totalAmount) - Joove.Common.safeNumber(alreadyPaidAmount);
if (CLMS.Framework.Number.LessThan(() => remainingAmount, () => 0)) {remainingAmount = 0;}
line.PaymentAmount = remainingAmount;
}
static GetCheck($this: any): any{if (!(Domain.Payment.HasCheck($this))) {return null;}
let paymentLine = $this?.Lines?.linq?.where((l) => l?.PaymentMethod != null && Domain.PaymentMethodDetailTypeValueObject.IsCheck(l?.PaymentMethod) && l?.Check != null && !(Domain.Check.IsNew(l?.Check)))?.firstOrDefault(null);
return paymentLine?.Check;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetPaidOrReceivedAmount($this: any): any{return $this?.Lines?.linq?.sum((l) => l?.PaymentAmount);
}
static HasCheck($this: any): any{for (let _iline = 0; _iline < ($this?.Lines == null ? 0 : $this?.Lines.length); _iline++) {let line = $this?.Lines[_iline];if (Domain.PaymentLine.HasCheck(line)) {return true;}}
return false;
}
static Init(businessEntity: any,amount: any,isIncome: any): any{let pi = new Domain.Payment();
pi.DatePayed = moment().toDate();
Domain.Payment.setEntity(pi, businessEntity);
pi.IsIncome = (isIncome != null ? isIncome : false);
let line = new Domain.PaymentLine();
line.PaymentAmount = amount;
pi?.Lines?.add(line);
return pi;
}
static IsAmountOk($this: any, amount: any): any{return CLMS.Framework.Number.Equal(() => $this.Lines.linq.sum((l) => l.PaymentAmount), () => amount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}